import { Star } from '@components/star';
import { TProduct, TStore, TStoreProduct } from '@components/types';
import { getCombinedName } from '@components/variant/variantSelector';
import { getImageObject, sanityIoImageLoader } from '@core/utils';
import Image from 'next/image';
import React from 'react';

type Props = {
    element?: TProduct
    setSelectedProduct?: Function
    setIsOpen?: Function
    isOpen?: boolean
    store?: TStore
}

const SpecialProductCard: React.FC<Props> = ({ element, setSelectedProduct, setIsOpen, isOpen, store }) => {
    return (
        <div className="flex flex-col max-w-50 w-full gap-1">
            <div className="max-h-50 h-50 rounded overflow-hidden border-[1px] border-solid bg-neutral-100 border-neutral-200 text-center" onClick={(e) => { setSelectedProduct(element); setIsOpen(!isOpen) }}>
                <Image
                    loader={sanityIoImageLoader}
                    src={getImageObject(element?.images)?.url}
                    alt={
                        getImageObject(element?.images)?.description ||
                        element?.name ||
                        'Product'
                    }
                    width="200"
                    height="200"
                    className="h-full"
                />
            </div>
            <div className="flex flex-col flex-grow justify-between gap-1 font-medium">
                <p className="font-manrope text-base leading-tight line-clamp-2 font-semibold overflow-visible py-0.5 overflow-hidden">{element?.name}</p>
                {element?.stats?.rating_count > 0 &&
                    <div className="flex flex-row gap-4 justify-between">
                        <div><Star rating={element?.stats?.rating_overall} /></div>
                        <div className="text-sm whitespace-nowrap">{element?.stats?.rating_count} Ratings</div>
                    </div>}
            </div>
        </div>)
}

export default SpecialProductCard